import { Paper, TableContainer } from "@mui/material";

type props = {
    children: JSX.Element, 
    mt?: number, 
    mb?: number
}

export const SectionWrapper = ({children, mt = 1, mb}: props) => {
    return (
        <Paper elevation={6} sx={{mt: mt, mb: mb}}>
            <TableContainer  >
                {children}
            </TableContainer>
        </Paper>
    );
}